import { QuestionTypes } from './enums'
import { QuestionData } from './types'

export default function isFileQuestion(value: QuestionData): value is QuestionData<[]> {
  return value.type === QuestionTypes.FILE
}
